import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const backofficeApi = createApi({
  reducerPath: "backofficeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://dev.mimobackoffice.com/api/", // = PLUS API
    //baseUrl: "https://devtest.mimobackoffice.com/api/",// = TEST API for plus
    //baseUrl: "https://api.mimobackoffice.com/api/",// = Cloud API
    //baseUrl: "https://apitest.mimobackoffice.com/api/",// = TEST API for cloud
		//baseUrl: "http://localhost:49981/api/", // local to RV mimo
    //baseUrl:"https://mimodev200.mimo-llc.com/api/",
		//baseUrl: "http://localhost/api", // local host Connection (IIS IS NEEDED if testing with API)
    prepareHeaders: (headers, { getState }) => {
      const token = window.sessionStorage.getItem("mimo_api_token");
      if (token != null) {
        headers.set("authorization", `Bearer ${token.replace(/"/g, "")}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Transaction', 'User', 'Department', 'Register', 'Member', 'Location'],

  endpoints: (builder) => ({
    //use builder.query for retrieving data on server i.e. GET
    //use builder.mutation for changing data on server i.e. POST PUT

    //AUTH QUERY
    postAuthorize: builder.mutation({
      query: ({ body }) => ({
        url: `authorize`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),

    //TRANSACTION QUERIES
    getAllTransactions: builder.query({
      query: (locationID) => `transaction?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedTransactionArray = [];

        // return empty list if response is null
        if(response==null) return transformedTransactionArray;

        response.forEach((transaction) =>{
          transformedTransactionArray.push({
            transactionID: transaction.id,
            name: transaction.name,
            typeId: transaction.typeId,
            vault: transaction.vault,
            isPayout: transaction.isPayout,
            payoutCategoryId: transaction.payoutCategoryId,
            bounding: transaction.bounding,
            enabled: transaction.enabled,
          });
        });
        return transformedTransactionArray;
      },
      providesTags: ['Transaction'],

    }),

    getTransactionsByDepartmentId: builder.query({
      query: ({locationID, departmentID}) => `transaction/DepartmentId?locationId=${locationID}&id=${departmentID}`,
      transformResponse: (response) => {
        let transformedTransactionArray = [];
        response.forEach((transaction) =>{
          transformedTransactionArray.push({
            transactionID: transaction.id,
            name: transaction.name,
            typeId: transaction.typeId,
            vault: transaction.vault,
            isPayout: transaction.isPayout,
            payoutCategoryId: transaction.payoutCategoryId,
            bounding: transaction.bounding,
            enabled: transaction.enabled,
          });
        });
        return transformedTransactionArray;
      },
      providesTags: ['Transaction'],

    }),

    getTransactionByTransactionId: builder.query({
        query: (locationID, transactionID) => `transaction?transactionID=${transactionID}`,
        transformResponse: (response) => {
            const transaction = {
            transactionID: transaction.id,
            name: transaction.name,
            typeId: transaction.typeId,
            vault: transaction.vault,
            isPayout: transaction.isPayout,
            payoutCategoryId: transaction.payoutCategoryId,
            bounding: transaction.bounding,
            enabled: transaction.enabled,
            }
            return transaction;
        }
    }),

    postAddTransaction: builder.mutation({
        query: ({body}) => ({
           url: `transaction/`,
           method: "POST",
           body: body,
           responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ['Transaction'],
    }),

    putUpdateTransaction: builder.mutation({
        query: ({ body }) => ({
            url: `transaction/`,
            method: "PUT",
            body: body,
            responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ['Transaction', 'Department'],
    }),

    putUpdateTransactionEnabled: builder.mutation({
      query: ({ body }) => ({
          url: `transaction/enabled`,
          method: "PUT",
          body: body,
          responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['Transaction'],
  }),

    //GETAllTERMINALIDs
    getAllTerminals: builder.query({
      query: (locationID) => `terminal?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedTerminalArray = [];
        response.forEach((terminal) => {
          transformedTerminalArray.push({
            terminalID: terminal.id,
            name: terminal.name,
            hostname: terminal.hostname,
            userSessionId: terminal.userSessionId,
            enabled: terminal.enabled,
          });
        });
        return transformedTerminalArray;
      },
      providesTags: ['Transaction'],
    }),

    //GetAllTokenByTerminalIds
    getAllTokensByTerminalIDs: builder.query({
      query: ({locationID, terminalIds}) => `token/terminals?locationID=${locationID}&terminalIds=${terminalIds}`,
      transformResponse: (response) => {
        let transformedTokenArray = [];
        response.forEach((token) => {
          transformedTokenArray.push({
            tokenID: token.id,
            currencyId: token.currencyId,
            typeId: token.typeId,
            name: token.name,
            value: token.value,
            exponentialValue: token.exponentialValue,
            count: token.count,
            dateCreated: token.dateCreated,
            enabled: token.enabled,
          })
        });
        return transformedTokenArray;
      },
      providesTags: ['Transaction'],
    }),

    //GetAllTransactionTokenIds
    GetAllTransactionTokenIds: builder.query({
      query: (locationID) => `transaction/GetAllTransactionTokenIds?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedTokenIdsArray = [];
        response.forEach((transacion) =>{
          transformedTokenIdsArray.push({
            transactionID: transacion.transactionId,
            tokenId: transacion.tokenId,
            count: transacion.count,
          });
        });
        return transformedTokenIdsArray;
      },
      providesTags: ['Transaction'],
    }),

    //GetAllTransactionTokenTypeIds
    GetAllTransactionTokenTypeIds: builder.query({
      query: (locationID) => `transaction/GetAllTransactionTokenTypes?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedTokenTypeIdsArray = [];
        response.filter(t => t.enabled === true).forEach((tokenType) =>{
          transformedTokenTypeIdsArray.push({
            transactionID: tokenType.transactionId,
            tokenTypeId: tokenType.tokenTypeId,
          });
        });
        return transformedTokenTypeIdsArray;
      },
      providesTags: ['Transaction'],
    }),

    //GetAllTransactionTokenTypeIdsByTransactionID
    getAllTokenTypeIdsByTransactionID: builder.query({
      query: ({locationID, transactionId}) => `transaction/GetByTransactionId?locationID=${locationID}&transactionID=${transactionId}`,
      transformResponse: (response) => {
        let transformedTokenTypeIdsArray = [];
        response.forEach((tokenType) =>{
          transformedTokenTypeIdsArray.push({
            transactionID: tokenType.transactionId,
            tokenTypeId: tokenType.tokenTypeId,
            enabled: tokenType.enabled,
            dateCreated: tokenType.dateCreated,
          });
        });
        return transformedTokenTypeIdsArray;
      },
      providesTags: ['Transaction'],
    }),

    //USER QUERIES
    getAllUsers: builder.query({
      query: (locationID) => `user?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedUserArray = [];

        // return empty list if response is null
        if(response==null) return transformedUserArray;

        response.forEach((user) =>{
          transformedUserArray.push({
            userID: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            groupId: user.groupId,
            secondaryId: user.secondaryId,
            dispenseLimit: user.dispenseLimit,
            dailyDispenseLimit: user.dailyDispenseLimit,
            dailyPayoutLimit: user.dailyPayoutLimit,
            employeeId: user.employeeId,
            enabled: user.enabled,
          });
        });
        return transformedUserArray;
      },
      providesTags: ['User'],

    }),

    getUserByUserId: builder.query({
        query: (locationID, userID) => `user?userID=${userID}`,
        transformResponse: (response) => {
            const user = {
            userID: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            groupId: user.groupId,
            secondaryId: user.secondaryId,
            dispenseLimit: user.dispenseLimit,
            dailyDispenseLimit: user.dailyDispenseLimit,
            dailyPayoutLimit: user.dailyPayoutLimit,
            employeeId: user.employeeId,
            enabled: user.enabled,
            }
            return user;
        }
    }),

    getUsersByDepartmentId: builder.query({
      query: ({locationID, departmentID}) => `user/DepartmentId?locationId=${locationID}&id=${departmentID}`,
      transformResponse: (response) => {
        let transformedUserArray = [];
        response.forEach((user) =>{
          transformedUserArray.push({
            userID: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            groupId: user.groupId,
            secondaryId: user.secondaryId,
            dispenseLimit: user.dispenseLimit,
            dailyDispenseLimit: user.dailyDispenseLimit,
            dailyPayoutLimit: user.dailyPayoutLimit,
            employeeId: user.employeeId,
            enabled: user.enabled,
          });
        });
        return transformedUserArray;
      },
      invalidatesTags: ['User'],
  }),

    postAddUser: builder.mutation({
        query: ({body}) => ({
           url: `user/`,
           method: "POST",
           body: body,
           responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ['User'],
    }),

    putUpdateUser: builder.mutation({
        query: ({ body }) => ({
            url: `user/`,
            method: "PUT",
            body: body,
            responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ['User'],
    }),

    putUpdateUserPassword: builder.mutation({
      query: ({ body }) => ({
          url: `user/ChangePassword`,
          method: "PUT",
          body: body,
          responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['User'],
  }),

    //GROUP QUERIES
    getAllGroups: builder.query({
      query: (locationID) => `group?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedGroupArray = [];
        // return empty list if response is null
        if(response==null) return transformedGroupArray;
        response.forEach((group) =>{
          transformedGroupArray.push({
            groupId: group.id,
            name: group.name,
            groupTypeId: group.GroupTypeId,
            accessibleGroups: group.AccessibleGroups,
            enabled: group.enabled,
            dateCreated: group.dateCreated,
          });
        });
        return transformedGroupArray;
      }
    }),

    //DEPARTMENT QUERIES
    getAllDepartments: builder.query({
      query: (locationID) => `department?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedDepartmentArray = [];
        if(response==null) return transformedDepartmentArray;
        response.forEach((department) =>{
          transformedDepartmentArray.push({
            departmentID: department.id,
            name: department.name,
            registerBalanced: department.registerBalanced,
            iconName: department.iconName,
            enabled: department.enabled,
            dateCreated: department.dateCreated,
          });
        });
        return transformedDepartmentArray;
      },
      providesTags: ['Department'],

    }),

    getAllDepartmentsByTransactionID: builder.query({
      query: ({locationID, transactionId, onlyEnabled}) => `department/transaction?locationID=${locationID}&transactionID=${transactionId}&onlyEnabled=${onlyEnabled}`,
      transformResponse: (response) => {
        let transformedDepartmentArray = [];
        response.forEach((department) =>{
          transformedDepartmentArray.push({
            departmentID: department.id,
            name: department.name,
            registerBalanced: department.registerBalanced,
            iconName: department.iconName,
            enabled: department.enabled,
            dateCreated: department.dateCreated,
          });
        });
        return transformedDepartmentArray;
      },
      providesTags: ['Department'],

    }),

    getDepartmentByDepartmentId: builder.query({
        query: (locationID, departmentID) => `department?departmentID=${departmentID}`,
        transformResponse: (response) => {
            const department = {
                departmentID: department.id,
                name: department.name,
                registerBalanced: department.registerBalanced,
                iconName: department.iconName,
                dateCreated: department.dateCreated,
            }
            return department;
        }
    }),

    getAllDepartmentsByUserId: builder.query({
      query: ({locationID, userID}) => `department/user?locationId=${locationID}&userId=${userID}&onlyEnabled=true`,
      transformResponse: (response) => {
        let transformedDepartmentArray = [];
        response.forEach((department) =>{
          transformedDepartmentArray.push({
            departmentID: department.id,
            name: department.name,
            registerBalanced: department.registerBalanced,
            iconName: department.iconName,
            enabled: department.enabled,
            dateCreated: department.dateCreated,
          });
        });
        return transformedDepartmentArray;
      },
      providesTags: ['Department'],
  
    }),

    postAddDepartment: builder.mutation({
        query: ({body}) => ({
           url: `department/`,
           method: "POST",
           body: body,
           responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ['Department'],
    }),

    putUpdateDepartment: builder.mutation({
        query: ({ body }) => ({
            url: `department/`,
            method: "PUT",
            body: body,
            responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ['Department'],
    }),

    //REGISTER QUERIES
    getAllRegisters: builder.query({
      query: (locationID) => `register?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedRegisterArray = [];
        response.forEach((register) =>{
          transformedRegisterArray.push({
            registerID: register.id,
            name: register.name,
            departmentID: register.departmentId,
            enabled: register.enabled,
            dateCreated: register.dateCreated,
          });
        });
        return transformedRegisterArray;
      },
      providesTags: ['Register'],
    }),

    getRegistersByDepartmentId: builder.query({
      query: ({locationID, departmentID}) => `register/DepartmentId?locationId=${locationID}&id=${departmentID}`,
      transformResponse: (response) => {
        let transformedRegisterArray = [];
        response.forEach((register) =>{
          transformedRegisterArray.push({
            registerID: register.id,
            name: register.name,
            departmentID: register.departmentId,
          });
        });
        return transformedRegisterArray;
      },
      invalidatesTags: ['Register'],
  }),

    //MEMBER QUERIES
    getAllMembers: builder.query({
      query: () => `member/`,
      transformResponse: (response) => {
        let transformedMembersArray = [];
        response.forEach((member) => {
          transformedMembersArray.push({
            memberID: member.MemberId,
            firstName: member.FirstName,
            lastName: member.LastName,
            role: member.RoleId === 1 ? "Admin" : member.RoleId === 2 ? "Viewer" : member.RoleId === 3 ? "Service" : member.RoleId === 4 ? "Integration" : member.RoleId === 5 ? "Billing" : "",
            organization: member.OrganizationName,
            locations: member.Locations,
            department: member.OrganizationName,
            email: member.Email,
            phone: member.Phone,
            enabled: member.Enabled === 1 ? "Enabled" : "Disabled",
            theme: member.Theme,
            organizationID: member.OrganizationId,
            permissions: member.Permissions,
          });
        });
        return transformedMembersArray;
      },
      providesTags: ['Member'],
    }),
    getMemberByMemberID: builder.query({
      query: (memberID) => `member?memberID=${memberID}`,
      transformResponse: (response) => {
        const member = {
          memberID: response.MemberId,
          firstName: response.FirstName,
          lastName: response.LastName,
          role: response.RoleId === 1 ? "Admin" : response.RoleId === 2 ? "Viewer" : response.RoleId === 3 ? "Service" : response.RoleId === 4 ? "Integration" : response.RoleId === 5 ? "Billing" : "",
          department: response.OrganizationName,
          organizationID: response.OrganizationId,
          organizationName: response.OrganizationName,
          email: response.Email,
          phone: response.Phone,
          theme: response.Theme,
          locations: response.Locations,
        };
        return member;
      },
    }),
    getMemberByMemberEmail: builder.query({
      query: (memberEmail) => `member?memberEmail=${memberEmail}`,
      responseHandler: (response) => response.text(),
      transformResponse: (response) => {
        const member = {
          memberID: response.MemberId,
          firstName: response.FirstName,
          lastName: response.LastName,
          role: response.RoleId === 1 ? "Admin" : response.RoleId === 2 ? "Viewer" : response.RoleId === 3 ? "Service" : response.RoleId === 4 ? "Integration" : response.RoleId === 5 ? "Billing" : "",
          department: response.OrganizationName,
          organizationID: response.OrganizationId,
          organizationName: response.OrganizationName,
          email: response.Email,
          phone: response.Phone,
          theme: response.Theme,
          locations: response.Locations,
          permissions: response.Permissions,
        };
        //console.log("BackOfficeAPI MEMBER DATA", response)
        return member;
      },
      providesTags: ['Member'],
    }),

    

    getMembersByOrganizationID: builder.query({
      query: (organizationID) => `member/organization?organizationID=${organizationID}`,
      transformResponse: (response) => {
        let transformedMembersArray = [];
        response.forEach((member) => {
          transformedMembersArray.push({
            memberID: member.MemberId,
            firstName: member.FirstName,
            lastName: member.LastName,
            role: response.RoleId === 1 ? "Admin" : response.RoleId === 2 ? "Viewer" : response.RoleId === 3 ? "Service" : response.RoleId === 4 ? "Integration" : response.RoleId === 5 ? "Billing" : "",
            organization: member.OrganizationName,
            locations: member.Locations,
            department: member.OrganizationName,
            email: member.Email,
            phone: member.Phone,
            enabled: member.Enabled === 1 ? "Enabled" : "Disabled",
            theme: member.Theme,
            organizationID: member.OrganizationId,
          });
        });
        transformedMembersArray = transformedMembersArray.filter((member) => member.role === "Admin" || member.role === "Viewer");
        return transformedMembersArray;
      },
      providesTags: ['Member'],
    }),
    getMembersByLocationID: builder.query({
      query: (locationID) => `member/location?locationID=${locationID}`,
      transformResponse: (response) => {
        let transformedMembersArray = [];
        response.forEach((member) => {
          transformedMembersArray.push({
            memberID: member.MemberId,
            firstName: member.FirstName,
            lastName: member.LastName,
            role: response.RoleId === 1 ? "Admin" : response.RoleId === 2 ? "Viewer" : response.RoleId === 3 ? "Service" : response.RoleId === 4 ? "Integration" : response.RoleId === 5 ? "Billing" : "",
            organization: member.OrganizationName,
            locations: member.Locations,
            department: member.OrganizationName,
            email: member.Email,
            phone: member.Phone,
            enabled: member.Enabled === 1 ? "Enabled" : "Disabled",
            theme: member.Theme,
            organizationID: member.OrganizationId,
          });
        });
        return transformedMembersArray;
      },
      providesTags: ['Member'],
    }),
    postAddMember: builder.mutation({
      query: ({ body }) => ({
        url: `member/add`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['Member'],
    }),
    postChangeMemberStatus: builder.mutation({
      query: ({ body }) => ({
        url: `member/changememberstatus`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    postChangeMemberPassword: builder.mutation({
      query: ({ body }) => ({
        url: `member/changepassword`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['Member'],
    }),
    putUpdateMember: builder.mutation({
      query: ({ body }) => ({
        url: `member/update`,
        method: "PUT",
        body: body,
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['Member'],
    }),
    putUpdateTheme: builder.mutation({
      query: ({ body }) => ({
        url: `member/updatetheme`,
        method: "PUT",
        body: body,
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['Member'],
    }),
    //NOTIFCATIONS
    getAlertsByMemberID: builder.query({
      query: (memberID) => `memberAlert?memberID=${memberID}`,
      transformResponse: (response) => {
        let transformedAlertsArray = [];

        response.forEach((alert) => {
          transformedAlertsArray.push({
            MemberAlertID: alert.MemberAlertID,
            // MemberID: alert.MemberID,
						LocationID: alert.LocationID,
            AlertTypeID: alert.AlertTypeID,
            AlertTypeName: alert.AlertTypeName,
            AlertMethodID: alert.AlertMethodID,
            AlertMethodName: alert.AlertMethodName,
            DaysSelected: alert.DaysSelected,
            StartTime: [parseInt(alert.StartTime.split("T").pop().split(":")[0]), 0, 0],
            EndTime: [parseInt(alert.EndTime.split("T").pop().split(":")[0]), 0, 0],
            TimeDelay: [parseInt(alert.TimeDelay.split(":")[0]), 0, 0],
            Percentage: alert.Percentage,
            MinThreshold: alert.MinThreshold,
            MaxThreshold: alert.MaxThreshold,
            Enabled: alert.Enabled,
          });
        });
        // console.log("Member Alerts", transformedAlertsArray)
        return transformedAlertsArray;
      },
    }),
    patchUpdateAlert: builder.mutation({
      query: ({ body }) => ({
        url: `memberalert/update`,
        method: "PATCH",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    postDisableAlert: builder.mutation({
      query: ({ body }) => ({
        url: `memberalert/disable`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    //AutoReports
    getAutoReportsByMemberID: builder.query({
      query: (memberID) => `autoreport?memberID=${memberID}`,
      transformResponse: (response) => {
        let transformedAutoReportsArray = [];

        response.forEach((autoReport) => {
          transformedAutoReportsArray.push({
            MemberReportID: autoReport.MemberReportID,
            LocationID: autoReport.LocationID,
            ReportName: autoReport.ReportName,
            DaysSelected: autoReport.DaysSelected,
            TimeToDeliver: [parseInt(autoReport.TimeToDeliver.split("T").pop().split(":")[0]), 0, 0],
            NumberOfDays: autoReport.NumberOfDays,
            Enabled: autoReport.Enabled,
          });
        });
        return transformedAutoReportsArray;
      },
    }),
    postAddAutoReport: builder.mutation({
      query: ({ body }) => ({
        url: `autoreport/add`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    postDisableAutoReport: builder.mutation({
      query: ({ body }) => ({
        url: `autoreport/disable`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    //LOCATIONS
    getAllLocations: builder.query({
      query: () => `location/`,
      transformResponse: (response) => {
        let transformedLocationsArray = [];

        response.forEach((location) => {
          transformedLocationsArray.push({
            LocationID: location.LocationID,
            LocationName: location.LocationName,
            OrganizationID: location.OrganizationID,
            TimeZoneID: location.TimeZoneID,
            TimeZoneName: location.TimeZoneName,
            LocationDatabaseName: location.LocationDatabaseName,
            APIUser: location.APIUser,
            APIPassword: location.APIPassword,
            APIID: location.LocationID,
          });
        });
        return transformedLocationsArray;
      },
      providesTags: ['Location'],
    }),
    getAllLocationsByOrganizationID: builder.query({
      query: (organizationID) => `location?organizationID=${organizationID}`,
      transformResponse: (response) => {
        let transformedLocationsArray = [];

        response.forEach((location) => {
          transformedLocationsArray.push({
            LocationID: location.LocationID,
            LocationName: location.LocationName,
            OrganizationID: location.OrganizationID,
            TimeZoneID: location.TimeZoneID,
            TimeZoneName: location.TimeZoneName,
            LocationDatabaseName: location.LocationDatabaseName,
            APIUser: location.APIUser,
            APIPassword: location.APIPassword,
            APIID: location.LocationID,
          });
        });
        return transformedLocationsArray;
      },
      providesTags: ['Location'],
    }),
    getMemberLocationsByEmail: builder.query({
      query: (email) => `location/getmemberlocations?email=${email}`,
      transformResponse: (response) => {
        let transformedLocationsArray = [];

        response.forEach((location) => {
          transformedLocationsArray.push({
            LocationID: location.LocationID,
            LocationName: location.LocationName,
            OrganizationID: location.OrganizationID,
            TimeZoneID: location.TimeZoneID,
            TimeZoneName: location.TimeZoneName,
            LocationDatabaseName: location.LocationDatabaseName,
            APIUser: location.APIUser,
            APIPassword: location.APIPassword,
            APIID: location.LocationID,
          });
        });
        return transformedLocationsArray;
      },
    }),
    postAddLocation: builder.mutation({
      query: ({ body }) => ({
        url: `location/add`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['Location'],
    }),
    getAllOrganizations: builder.query({
      query: () => `organization/`,
      transformResponse: (response) => {
        let transformedOrganizationsArray = [];
        response.forEach((organization) => {
          transformedOrganizationsArray.push({
            OrganizationID: organization.OrganizationID,
            OrganizationName: organization.OrganizationName,
            PasswordsExpireIn: organization.PasswordsExpireIn,
            TotalLicenses: organization.TotalLicenses,
            LicensesInUse: organization.LicensesInUse,
            LicensesExpire: organization.DateExpires.split("T")[0],
            LicenseStatus: organization.LicenseStatus === 1 ? "Enabled" : "Disabled",
          });
        });
        return transformedOrganizationsArray;
      },
    }),
    getOrganizationByOrganizationID: builder.query({
      query: (organizationID) => `organization?organizationID=${organizationID}`,
      transformResponse: (response) => {
        let organization = {};
        organization.OrganizationID = response.OrganizationID;
        organization.OrganizationName = response.OrganizationName;
        organization.PasswordsExpireIn = response.PasswordsExpireIn;
        organization.TotalLicenses = response.TotalLicenses;
        organization.LicensesInUse = response.LicensesInUse;
        organization.LicensesExpire = response.DateExpires.split("T")[0];
        organization.LicenseStatus = response.LicenseStatus === 1 ? "Enabled" : "Disabled";

        
        return organization;
      },
    }),
    postAddOrganization: builder.mutation({
      query: ({ body }) => ({
        url: `organization/add`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    putUpdateTotalLicenses: builder.mutation({
      query: ({ body }) => ({
        url: `organization/updateTotalLicenses`,
        method: "PUT",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    putChangeLicenseStatus: builder.mutation({
      query: ({ body }) => ({
        url: `organization/changelicensestatus`,
        method: "PUT",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    putRenewLicense: builder.mutation({
      query: ({ body }) => ({
        url: `organization/renewlicense`,
        method: "PUT",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    getAllRoles: builder.query({
      query: () => `role/`,
      transformResponse: (response) => {
        let transformedRolesArray = [];

        response.forEach((role) => {
          transformedRolesArray.push({
            roleID: role.RoleId,
            roleName: role.RoleName,
          });
        });
        return transformedRolesArray;
      },
    }),
    getAllTimeZones: builder.query({
      query: () => `timezone`,
      transformResponse: (response) => {
        let transformedTimeZonesArray = [];

        response.forEach((timezone) => {
          transformedTimeZonesArray.push({
            timeZoneID: timezone.TimeZoneId,
            timeZoneName: timezone.TimeZoneName,
          });
        });
        return transformedTimeZonesArray;
      },
    }),
    postOpenMemberSession: builder.mutation({
      query: ({ body }) => ({
        url: `member/openmembersession`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    getCheckIfMemberSessionOpen: builder.query({
      query: (memberSessionID) => `member/checkifmembersessionopen?membersessionid=${memberSessionID}`,
    }),
    getIsFirstLogin: builder.query({
      query: (memberID) => `member/isfirstlogin?memberid=${memberID}`,
    }),
    //MIMO Data
    GetMostRecentlyClosedBusinessDate: builder.query({
      async queryFn({ locationId }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`businessdate/mostrecentlyclosed?locationId=${locationId}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetMostRecentStartingADayAgo: builder.query({
      async queryFn({ locationId, startTime }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`businessdate/mostrecentstartingadayago?locationId=${locationId}&startTime=${startTime}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),

    //Get Report Data
    GetGrandTotalsReportByDateString: builder.query({
      async queryFn({ locationId, terminalId, startDate, endDate, deviceId }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/grandtotalsbydatestring?locationid=${locationId}&terminalid=${terminalId}&startDate=${startDate}&endDate=${endDate}&deviceid=${deviceId}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
		GetGrandTotalsByDenominationReportByDateString: builder.query({
			async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
				const result = await fetchWithBQ(`reports/grandtotalsbydenominationbydatestring?locationid=${locationId}&startDate=${startDate}&endDate=${endDate}`);
				return result.data ? { data: result.data } : { error: result.error };
			},
		}),
    GetDailyTotalsReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/dailytotalsbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetManualDropDetailReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/manualdropdetailbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetMiscMediaDetailReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/miscmediadetailbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetAverageNoteCountReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/averagenotecountbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        //console.log("Results in BackOfficeAPI Data Average Notes:", result.data)
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetPayoutDetailReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/payoutdetailbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetDepartmentProfileReport: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/departmentprofile?locationid=${locationId}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetDetailReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/detailbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
		GetRefillDetailReportByDateString: builder.query({
			async queryFn({ locationId, startDate, terminalId }, _queryApi, _extraOptions, fetchWithBQ) {
				const result = await fetchWithBQ(`reports/refilldetailbydatestring?locationid=${locationId}&startDate=${startDate}`);
				return result.data ? { data: result.data } : { error: result.error };
			},
		}),
		GetRefillSummaryReportByDateString: builder.query({
			async queryFn({ locationId, startDate, terminalId }, _queryApi, _extraOptions, fetchWithBQ) {
				const result = await fetchWithBQ(`reports/refillsummarybydatestring?locationid=${locationId}&startDate=${startDate}`);
				return result.data ? { data: result.data } : { error: result.error };
			},
		}),
    GetRegisterSummaryReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/registersummarybydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetTerminalSummaryReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/terminalsummarybydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetTransactionLogReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/transactionlogbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetUserProfileReport: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/userprofile?locationid=${locationId}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetUserSummaryReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/usersummarybydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetVaultTransactionsReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/vaulttransactionsbydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),
    GetMIMOBalanceReportByDateString: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`reports/mimobalancebydatestring?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),

    // GetTipsReportByDateString: builder.query({
    //   async queryFn({locationId, startDate, endDate}, _queryApi, _extraOptions, fetchWithBQ){
    //     const result = await fetchWithBQ(`reports/tipsreportbydatestring?locationsid=${locationId}&startdate=${startDate}&enddate=${endDate}`);
    //     return result.data ? {data: result.data } : {error: result.error};
    //   },
    // }),

    //BO-26 
    GetAllTipoutDetailReports: builder.query({
      async queryFn({ locationId, startDate, endDate }, _queryApi, _extraOptions, fetchWithBQ) {
        // Fix the parameter name from `locationsid` to `locationId`
        const result = await fetchWithBQ(
          `reports/GetAllTipoutDetailReports?locationId=${locationId}&startDate=${startDate}&endDate=${endDate}`
        );
    
        if (result.error) {
          return { error: result.error };
        }
    
        if (result.data) {
          return { data: result.data };
        }
    
        //console.log("tip results", result);
        // Fallback if both data and error are undefined
        return { error: "Unknown error occurred while fetching Tips Report" };
      },
    }),
    

    // GetOpenTillReportByDateString: builder.query({
    //   async queryFn({ locationId }, _queryApi, _extraOptions, fetchWithBQ) {
    //     const result = await fetchWithBQ(`reports/opentill?locationid=${locationId}`);
    //     return result.data ? { data: result.data } : { error: result.error };
    //   },
    // }),

    GetOpenTillReportByDateString: builder.query({
  async queryFn({ locationId }, _queryApi, _extraOptions, fetchWithBQ) {
    const result = await fetchWithBQ(`reports/opentill?locationid=${locationId}`);
    
    if (result.error) {
      return { error: result.error };
    }
    
    if (result.data) {
      return { data: result.data };
    }

    // Fallback if both data and error are undefined
    return { error: 'Unknown error occurred while fetching Open Till Report' };
    },
  }),

    // Get The Notes
    GetTheNotes: builder.query({
      async queryFn({ locationId, transactionSessionId }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`Token/GetTokensByTransactionSessionId?locationid=${locationId}&transactionSessionId=${transactionSessionId}`);
        return result.data ? { data: result.data } : { error: result.error };
      }
    }),
    // Get The Notes
    GetTheNotesWithPending: builder.query({
      async queryFn({ locationId, transactionSessionId }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`Token/GetTokensByTransactionSessionIdWithPending?locationid=${locationId}&transactionSessionId=${transactionSessionId}`);
        return result.data ? { data: result.data } : { error: result.error };
      }
    }),
    // Get The Notes From Transaction Session List
    GetTheNotesFromTransactionSessionList: builder.query({
      async queryFn({ locationId, transactionSessionIds }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`Token/GetTokensByTransactionSessionIds?locationid=${locationId}&transactionSessionIds=${transactionSessionIds}`);
        return result.data ? { data: result.data } : { error: result.error };
      }
    }),
    // MIMO Errors
    // getMIMOErrors: builder.query({
    //   async queryFn({ locationId, memberId, memberDismissedListString }, _queryApi, _extraOptions, fetchWithBQ) {
		// 		const result = await fetchWithBQ(`MIMOErrorAlert?locationid=${locationId}&memberid=${memberId}&timeDelaySeconds=10`)
    //     return result.data ? { data: result.data } : { error: result.error };
    //   },
    // }),

    getMIMOErrors: builder.query({
      async queryFn({ locationId, memberId, memberDismissedListString }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`MIMOErrorAlert?locationid=${locationId}&memberid=${memberId}&timeDelaySeconds=10`);
        if (result.error) {
          return { error: result.error };
        }
        if (result.data) {
          return { data: result.data };
        }
        // Handle the case where both data and error are undefined
        return { error: 'Unknown error occurred while fetching MIMO Errors' };
      },
    }),
    
    putReconcileError: builder.mutation({
      query: ({ body }) => ({
        url: `errorLog/reconcile`,
        method: "PUT",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    getDismissedAlertsList: builder.query({
			query: (memberID) => `DismissedAlert?memberid=${memberID}`,
      transformResponse: (response) => {
        let transformedDismissedList = [];
        response.forEach((dismissItem) => {
          transformedDismissedList.push({
            LocationID: dismissItem.LocationID,
            ErrorLogID: dismissItem.ExternalID,
          });
        });
        return transformedDismissedList;
      },
    }),
		postDismissAllErrorAlerts:
		builder.mutation({
			query: ({ body }) => ({
				url: `MIMOErrorAlert/DismissAll`,
				method: "POST",
				body: body,
				responseHandler: (response) => response.text(),
			}),
		}),
    postDismissErrorAlert: builder.mutation({
      query: ({ body }) => ({
        url: `member/dismisserroralert`,
        method: "POST",
        body: body,
        responseHandler: (response) => response.text(),
      }),
    }),
    // getThresholdAlertsList: builder.query({
    //   async queryFn({ locationId, min, max }, _queryApi, _extraOptions, fetchWithBQ) {
    //     const result = await fetchWithBQ(`thresholdalert?locationid=${locationId}&minimum=${min}&maximum=${max}&timeDelayMinutes=0`);
    //     return result.data ? { data: result.data } : { error: result.error };
    //   },
    // }),

    getThresholdAlertsList: builder.query({
      async queryFn({ locationId, min, max }, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`thresholdalert?locationid=${locationId}&minimum=${min}&maximum=${max}&timeDelayMinutes=0`);
        if (result.error) {
          return { error: result.error };
        }
        if (result.data) {
          return { data: result.data };
        }
        // Handle the case where both data and error are undefined
        return { error: 'Unknown error occurred while fetching Threshold Alerts' };
      },
    }),
    
    getThresholdCount: builder.query({
      query: ({ locationId }) => `thresholdCount?locationid=${locationId}`,
    }),
    getOpenTillCount: builder.query({
      query: ({ locationId }) => `reports/opentillcount?locationid=${locationId}`,
    }),
    getMIMOErrorsCount: builder.query({
      async queryFn({ locationId, memberId, memberDismissedListString}, _queryApi, _extraOptions, fetchWithBQ) {
        const result = await fetchWithBQ(`mimoerrorcount?locationid=${locationId}&memberid=${memberId}&memberDismissedListString=${memberDismissedListString}`);
        return result.data ? { data: result.data } : { error: result.error };
      },
    }),

/*
		getMIMOErrorsCount: builder.query({
      query: ({ locationId, memberId, memberDismissedListString }) => `mimoerrorcount?locationid=${locationId}&memberid=${memberId}&memberDismissedListString=${memberDismissedListString}`,
    }),
*/
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
// format of hook: use(NameOfEndpoint)(Query or Mutation depending on end point builder) ... i.e useNameOfEndPointQuery
export const {
  //MIMO Core
  useGetAllTokensByTerminalIDsQuery,
  useGetAllTransactionTokenIdsQuery,
  useGetAllTransactionTokenTypeIdsQuery,
  useGetAllTokenTypeIdsByTransactionIDQuery,
  useGetAllTerminalsQuery,
  useGetAllTransactionsQuery,
  useGetTransactionsByDepartmentIdQuery,
  useGetTransactionByTransactionIdQuery,
  usePostAddTransactionMutation,
  usePutUpdateTransactionMutation,
  usePutUpdateTransactionEnabledMutation,
  useGetAllUsersQuery,
  useGetUserByUserIdQuery,
  useGetUsersByDepartmentIdQuery,
  usePostAddUserMutation,
  usePutUpdateUserMutation,
  usePutUpdateUserPasswordMutation,
  useGetAllGroupsQuery,
  useGetAllDepartmentsQuery,
  useGetAllDepartmentsByTransactionIDQuery,
  useGetAllDepartmentsByUserIdQuery,
  useGetDepartmentByDepartmentIdQuery,
  usePostAddDepartmentMutation,
  usePutUpdateDepartmentMutation,
  useGetRegistersByDepartmentIdQuery,
  useGetAllRegistersQuery,
  //BackOffice
  useGetAllMembersQuery,
  useGetMemberByMemberIDQuery,
  useGetMemberByMemberEmailQuery,
  useGetMembersByOrganizationIDQuery,
  useGetMembersByLocationIDQuery,
  useGetAlertsByMemberIDQuery,
  usePatchUpdateAlertMutation,
  usePostDisableAlertMutation,
  useGetAutoReportsByMemberIDQuery,
  usePostAddAutoReportMutation,
  usePostDisableAutoReportMutation,
  useGetAllLocationsQuery,
  useGetAllLocationsByOrganizationIDQuery,
  useGetMemberLocationsByEmailQuery,
  useGetAllOrganizationsQuery,
  useGetOrganizationByOrganizationIDQuery,
  useGetAllRolesQuery,
  useGetAllTimeZonesQuery,
  usePostAuthorizeMutation,
  usePostAddMemberMutation,
  usePostChangeMemberStatusMutation,
  usePostAddOrganizationMutation,
  usePostAddLocationMutation,
  usePostChangeMemberPasswordMutation,
  usePutUpdateMemberMutation,
  usePutUpdateThemeMutation,
  usePutChangeLicenseStatusMutation,
  usePutUpdateTotalLicensesMutation,
  usePutRenewLicenseMutation,
  usePostOpenMemberSessionMutation,
  useGetCheckIfMemberSessionOpenQuery,
  useGetIsFirstLoginQuery,
  useGetMostRecentlyClosedBusinessDateQuery,
  useGetMostRecentStartingADayAgoQuery,
	useGetGrandTotalsReportByDateStringQuery,
  useGetGrandTotalsByDenominationReportByDateStringQuery,
  useGetDailyTotalsReportByDateStringQuery,
  useGetManualDropDetailReportByDateStringQuery,
  useGetMiscMediaDetailReportByDateStringQuery,
  useGetAverageNoteCountReportByDateStringQuery,
  useGetPayoutDetailReportByDateStringQuery,
  useGetDetailReportByDateStringQuery,
  useGetDepartmentProfileReportQuery,
	useGetRefillDetailReportByDateStringQuery,
	useGetRefillSummaryReportByDateStringQuery,
  useGetRegisterSummaryReportByDateStringQuery,
  useGetTerminalSummaryReportByDateStringQuery,
  useGetTransactionLogReportByDateStringQuery,
  useGetUserProfileReportQuery,
  useGetUserSummaryReportByDateStringQuery,
  useGetVaultTransactionsReportByDateStringQuery,
  useGetMIMOBalanceReportByDateStringQuery,
  useGetOpenTillReportByDateStringQuery,
  useGetAllTipoutDetailReportsQuery,
  useGetTheNotesQuery,
  useGetTheNotesWithPendingQuery,
  useGetTheNotesFromTransactionSessionListQuery,
  useGetMIMOErrorsQuery,
  usePutReconcileErrorMutation,
  useGetDismissedAlertsListQuery,
	usePostDismissAllErrorAlertsMutation,
  usePostDismissErrorAlertMutation,
  useGetThresholdAlertsListQuery,
  useGetMIMOErrorsCountQuery,
  useGetOpenTillCountQuery,
  useGetThresholdCountQuery,
} = backofficeApi;
